import config from "utils/config";

const charts = config.get("charts");

class TapCharts {
    constructor(opts) {
        return this;
    }
}

const tapCharts = ({ theme, language }) => {
    if (!charts) return;

    const setupCharts = () => {
        if (typeof charts !== "undefined" && charts) {
            for (var i = charts.length - 1; i >= 0; i--) {
                switch (charts[i].type) {
                    case "funnel":
                        setupFunnelChart(i);
                        break;

                    default:
                        setupSerialChart(i);
                        break;
                }
            }
        }
    };

    const setupSerialChart = i => {
        charts[i].ykeys = typeof charts[i].ykeys !== "undefined" ? charts[i].ykeys : ["value"];

        for (var ii = charts[i].data.length - 1; ii >= 0; ii--) {
            for (var iii = charts[i].ykeys.length - 1; iii >= 0; iii--) {
                var displayValueKey = charts[i].ykeys.length > 1 ? "displayValue" + iii : "displayValue";
                var valueKey = charts[i].ykeys.length > 1 ? "value" + iii : "value";
                charts[i].data[ii][displayValueKey] = parseInt(charts[i].data[ii][valueKey]);
            }
        }

        var chart = new AmCharts.AmSerialChart();
        chart.theme = theme;
        chart.language = language;
        chart.hideCredits = true;
        chart.pathToImages = "/bundles/tapsite/js/amcharts/images/";
        chart.marginTop = 10;
        chart.marginLeft = 0;

        chart.categoryField = typeof charts[i].xkey !== "undefined" ? xkey : "label";
        chart.dataDateFormat = typeof charts[i].dateFormat !== "undefined" ? charts[i].dateFormat : "YYYY-MM-DD";

        var categoryAxis = chart.categoryAxis;
        categoryAxis.gridAlpha = charts[i].type === "simple-line" ? 0 : 0.07;
        categoryAxis.axisColor = "#DADADA";
        categoryAxis.parseDates = typeof charts[i].parseDates !== "undefined" ? charts[i].parseDates : true;

        categoryAxis.equalSpacing = true;
        categoryAxis.startOnAxis = true;

        var valueAxis = new AmCharts.ValueAxis();
        valueAxis.theme = theme;
        valueAxis.language = language;
        valueAxis.gridAlpha = 0.07;
        valueAxis.integersOnly = true;

        chart.addValueAxis(valueAxis);

        for (var ii = charts[i].ykeys.length - 1; ii >= 0; ii--) {
            var graph = new AmCharts.AmGraph();
            graph.theme = theme;
            graph.language = language;

            switch (charts[i].type) {
                case "bar":
                    graph.type = "column";
                    break;

                case "simple-line":
                    graph.type = "line";
                    break;

                default:
                    graph.type = "line";
                    graph.bullet = "none";
                    graph.bulletBorderColor = "#FFFFFF";
                    graph.bulletBorderAlpha = 1;
                    break;
            }

            var balloonText;

            if (charts[i].balloonText) {
                balloonText = charts[i].balloonText;
            } else {
                balloonText = "<span style='font-size:14px; color:#000000;'>[[category]] | ";
                var displayValueKey = charts[i].ykeys.length > 1 ? "displayValue" + ii : "displayValue";

                balloonText += charts[i].ykeyNames && charts[i].ykeyNames[ii] ? charts[i].ykeyNames[ii] + ": " : "";
                balloonText += "<b>[[" + displayValueKey + "]]";
                balloonText += charts[i].percentile ? "%" : "";
                balloonText += "</b></span>";
            }

            graph.balloonText = balloonText;

            graph.valueField = charts[i].ykeys[ii];
            graph.lineAlpha = 1;
            graph.lineThickness = 2.5;
            graph.fillAlphas = 0;

            if (charts[i].graphThemes && charts[i].graphThemes[ii]) {
                switch (charts[i].graphThemes[ii]) {
                    case "maincolor":
                        graph.fillColors = "#76b2bf";
                        graph.lineColor = "#51a1f2";
                        break;
                    case "seccolor":
                        graph.fillColors = "#37d1b3";
                        graph.lineColor = "#28ad93";
                        break;
                    case "danger":
                        graph.fillColors = "#f05a3c";
                        graph.lineColor = "#e73512";
                        break;

                    case "yellow":
                        graph.fillColors = "#fcf8e3";
                        graph.lineColor = "#8a6d3b";
                        break;

                    default:
                        graph.fillColors = "#3f75c6";
                }
            }

            chart.addGraph(graph);
        }

        var hasSma = typeof charts[i].hasSma !== "undefined" ? charts[i].hasSma : false;

        if (hasSma) {
            var sma = new AmCharts.AmGraph();
            sma.theme = theme;
            sma.language = language;

            sma.type = "smoothedLine";
            sma.bullet = "round";
            sma.bulletBorderColor = "#FFFFFF";
            sma.bulletBorderAlpha = 1;

            var balloonText = "<span style='font-size:14px; color:#000000;'>[[category]] | ";
            balloonText += "SMA (3 month): ";
            balloonText += "<b>[[sma]]";
            balloonText += charts[i].percentile ? "%" : "";
            balloonText += "</b></span>";
            sma.balloonText = balloonText;

            sma.valueField = "sma";
            sma.lineAlpha = 1;
            sma.lineThickness = 2.5;
            sma.fillAlphas = 0;
            sma.fillColors = "#f05a3c";
            sma.lineColor = "#e73512";

            chart.addGraph(sma);
        }

        chart.dataProvider = charts[i].data;

        var chartCursor = new AmCharts.ChartCursor();
        chartCursor.cursorAlpha = 0.6;
        chartCursor.cursorColor = "#aaa";
        chart.addChartCursor(chartCursor);

        chart.write(charts[i].element);
    };

    const setupFunnelChart = i => {
        var chart = new AmCharts.AmFunnelChart();
        chart.theme = theme;
        chart.language = language;
        chart.hideCredits = true;

        chart.pathToImages = "/bundles/tapsite/js/amcharts/images/";
        chart.titleField = "label";
        chart.marginRight = 160;
        chart.marginLeft = 15;
        chart.labelPosition = "right";
        chart.funnelAlpha = 0.9;
        chart.valueField = "value";
        chart.startX = 0;
        chart.neckWidth = "40%";
        chart.startAlpha = 0;
        chart.outlineThickness = 1;
        chart.backgroundColor = "#333333";
        chart.neckHeight = "30%";

        chart.balloonText = "[[label]]:<b>[[value]]</b>";
        chart.labelText = "[[title]]: [[value]]";

        if (charts[i].percentile) {
            chart.balloonText += " ([[percentOfPreviousSlice]]% => Of total [[percentOfTotal]]%)";
            chart.labelText += " ([[percentOfPreviousSlice]]%)";
        }

        chart.dataProvider = convertToFunnelData(charts[i].data);

        chart.write(charts[i].element);
    };

    const convertToFunnelData = data => {
        var providerData = [];
        var keys = Object.keys(data);

        var prevVal = null;
        var initVal = null;

        for (var i = 0; i < keys.length; i++) {
            if (!prevVal) {
                prevVal = data[keys[i]];
                initVal = data[keys[i]];
            }

            var percentVal = (100 / prevVal) * data[keys[i]];
            var percentValRounded = Math.round(percentVal * 100) / 100;

            var initPercentVal = (100 / initVal) * data[keys[i]];
            var initPercentValRounded = Math.round(initPercentVal * 100) / 100;

            providerData.push({
                label: keys[i],
                value: data[keys[i]],
                percentOfPreviousSlice: percentValRounded,
                percentOfTotal: initPercentValRounded,
            });

            prevVal = data[keys[i]];
        }

        return providerData;
    };

    setupCharts();
};

let theme;
let locale = config.get("locale") || "en";

module.exports = Promise.all([import("tap-charts/themes/tapfiliate.js"), import("amcharts3")])
    .then(deps => {
        [theme] = deps;
        AmCharts.theme = theme;
        const importsToLoad = [import("amcharts3/amcharts/serial")];
        // Only load translation when necessary
        if (locale !== "en") {
            importsToLoad.push(import(`amcharts3/amcharts/lang/${locale}`));
        }
        return Promise.all([importsToLoad]);
    })
    .then(deps => {
        return Promise.all(deps[0]);
    })
    .then(() => {
        AmCharts.language = locale;
        return tapCharts({ theme, language: locale });
    });
